/* Sleep LP Score — pills game
   Tap pills to count stress signals. Center "TAP HERE" hint fades on
   first interaction; result chip + message appear below the grid. */
(function () {
  'use strict';

  function classify(count) {
    if (count <= 3) return 'safe';
    if (count <= 6) return 'mid';
    return 'high';
  }

  function initGame(root) {
    var game = root.querySelector('[data-sleep-score-game]');
    if (!game) return;
    var seal = root.querySelector('[data-sleep-score-seal]');
    var overlay = root.querySelector('[data-sleep-score-seal-overlay]');
    var pills = game.querySelectorAll('[data-sleep-score-pill]');
    var zoneEl = game.querySelector('[data-sleep-score-zone]');
    var countEl = game.querySelector('[data-sleep-score-count]');
    var msgEl = game.querySelector('[data-sleep-score-msg]');
    var totalPills = pills.length;
    var defaultZone = zoneEl ? zoneEl.textContent : '';
    var defaultMsg = msgEl ? msgEl.innerHTML : '';

    var labels = {
      safe: game.dataset.safeLabel || 'SAFE ZONE',
      mid: game.dataset.midLabel || 'AT-RISK',
      high: game.dataset.highLabel || 'OVERLOAD'
    };
    var msgTemplates = {
      safe: game.querySelector('[data-sleep-score-msg-safe]'),
      mid: game.querySelector('[data-sleep-score-msg-mid]'),
      high: game.querySelector('[data-sleep-score-msg-high]')
    };

    function update() {
      var selected = game.querySelectorAll('[data-sleep-score-pill].is-selected');
      var count = selected.length;
      if (count === 0) {
        game.classList.remove('is-engaged');
        game.dataset.zone = 'safe';
        if (zoneEl) zoneEl.textContent = labels.safe;
        if (countEl) countEl.textContent = '0/' + totalPills;
        if (msgEl && msgTemplates.safe) msgEl.innerHTML = msgTemplates.safe.innerHTML;
        return;
      }
      game.classList.add('is-engaged');
      var zone = classify(count);
      game.dataset.zone = zone;
      if (zoneEl) zoneEl.textContent = labels[zone];
      if (countEl) countEl.textContent = count + '/' + totalPills;
      if (msgEl && msgTemplates[zone]) {
        msgEl.innerHTML = msgTemplates[zone].innerHTML;
      }
    }

    function resetState() {
      pills.forEach(function (p) {
        p.classList.remove('is-selected');
        p.setAttribute('aria-pressed', 'false');
      });
      game.classList.remove('is-engaged');
      game.dataset.zone = 'safe';
      if (zoneEl) zoneEl.textContent = defaultZone || labels.safe;
      if (countEl) countEl.textContent = '0/' + totalPills;
      if (msgEl) {
        msgEl.innerHTML = (msgTemplates.safe && msgTemplates.safe.innerHTML) || defaultMsg;
      }
    }

    var teaserId = null;
    function tickTeaser() {
      var picks = 1 + Math.floor(Math.random() * pills.length);
      var indices = {};
      while (Object.keys(indices).length < picks) {
        indices[Math.floor(Math.random() * pills.length)] = true;
      }
      pills.forEach(function (p, i) {
        if (indices[i]) p.classList.add('is-selected');
        else p.classList.remove('is-selected');
      });
      update();
    }
    function startTeaser() {
      if (teaserId) return;
      tickTeaser();
      teaserId = setInterval(tickTeaser, 900);
    }
    function stopTeaser() {
      if (teaserId) {
        clearInterval(teaserId);
        teaserId = null;
      }
    }

    function reveal() {
      if (root.classList.contains('is-revealed')) return;
      root.classList.add('is-revealed');
      if (seal) seal.setAttribute('tabindex', '-1');
    }

    if (seal) seal.addEventListener('click', reveal);
    if (overlay) overlay.addEventListener('click', reveal);

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (!root.classList.contains('is-revealed')) return;
        if (teaserId) {
          stopTeaser();
          resetState();
        }
        pill.classList.toggle('is-selected');
        pill.setAttribute('aria-pressed', pill.classList.contains('is-selected') ? 'true' : 'false');
        update();
      });
    });

    if (!root.classList.contains('is-revealed')) {
      startTeaser();
    } else {
      update();
    }
  }

  function init() {
    document.querySelectorAll('[data-sleep-score]').forEach(initGame);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sleep-score]');
    if (root) initGame(root);
  });
})();
